import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IApiError } from '@models/iapi';
import { EnterBirthDateComponent, ForbiddenPaymentComponent } from '@shared/components';
import { API_URL } from '../../../environments/environment.constants';
import {
  financialMonitoringModalConfig,
  prodFinMonErrorCodes,
  stageFinMonErrorCodes,
} from './financial-monitoring.constants';

@Injectable()
export class FinancialMonitoringService {
  private readonly prodFinMonErrorCodes = prodFinMonErrorCodes;
  private readonly stageFinMonErrorCodes = stageFinMonErrorCodes;

  birthDateDialogRef: MatDialogRef<EnterBirthDateComponent>;
  senderDateOfBirth: string = null;

  constructor(private dialog: MatDialog) {
  }

  finMonErrorCodesEnum(): Record<string, string> {
    return (
      API_URL.includes('https://api1.dev.npu.np.work/v2.0/') ||
      // Reserved for dev env
      API_URL.includes('https://api2.dev.npu.np.work/v2.0/')
    )
      ? this.stageFinMonErrorCodes : this.prodFinMonErrorCodes;
  }

  getSenderDateOfBirth(): Record<string, string> {
    return { SenderDateOfBirth: this.senderDateOfBirth };
  }

  resetSenderDateOfBirth(): void {
    this.senderDateOfBirth = '';
  }

  checkFinMonErrors(errors: IApiError[]): boolean {
    if (errors.length == 0 || errors.length > 1) {
      return false;
    }

    return errors.some(e => Object.values(this.finMonErrorCodesEnum()).some(code => String(e.errorCode) === code));
  }

  handleFinMonitoringApiError(errors: IApiError[]): void {
    const error = errors[0];

    if (String(error.errorCode) === this.finMonErrorCodesEnum().NoBirthDate) {
      this.openBirthDatePopup();
      return;
    }

    if (error.errorCode == this.finMonErrorCodesEnum().InaccessibleFinancialServices) {
      this.openInaccessibleFinancialServicesPopup();
      return;
    }
  }

  openBirthDatePopup(): void {
    this.birthDateDialogRef = this.dialog.open(EnterBirthDateComponent, financialMonitoringModalConfig);
  }

  openInaccessibleFinancialServicesPopup(): void {
    this.dialog.open(ForbiddenPaymentComponent, financialMonitoringModalConfig);
  }
}
